import React, { useEffect, useState } from "react";
import Sidenav from "../common/Sidenav";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Header from "../common/Header";
import {
  School as SchoolIcon,
  LibraryBooks as LibraryBooksIcon,
  Person as PersonIcon,
  Event as EventIcon,
  LocalLibrary as LocalLibraryIcon,
} from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import SocialDistanceIcon from "@mui/icons-material/SocialDistance";
import SportsHandballIcon from "@mui/icons-material/SportsHandball";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import BookIcon from "@mui/icons-material/Book";
import ReviewsIcon from "@mui/icons-material/Reviews";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import NavigatedComponent from "./NavigatedComponent";
import { getUser } from "../../global/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../../config/config";
import { useCookies } from "react-cookie";
import IconSidenav from "../common/IconSidenav";

const Dashboard = () => {
  const location = useLocation();
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );
  const [showSideNav, setShowSideNav] = useState(false);
  const isSmallScreen = useMediaQuery(
    "(min-width:1024px) and (max-width:1440px)"
  );

  const toggleSideNav = () => {
    setShowSideNav(!showSideNav);
  };

  return (
    <>
      <Grid sx={{ display: "flex" }}>
        {isMobileScreen ? (
          <IconSidenav />
        ) : showSideNav ? (
          <IconSidenav />
        ) : (
          <Sidenav />
        )}
        <Grid component="main" sx={{ width: "100%", px: 1 }}>
          <Header toggleSideNav={toggleSideNav} />
          <Grid sx={{ py: 1 }}>
            <NavigatedComponent pathname={location.pathname} />
            <Box
              sx={{
                px: isMobileScreen ? 3 : isSmallScreen ? 3 : 5,
                my: isMobileScreen ? 2 : isSmallScreen ? 2 : 5,
              }}
            >
              <Grid
                container
                spacing={isMobileScreen ? 2 : isSmallScreen ? 2 : 4}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <SchoolIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#2e2e32",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Fresh leads
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />
                      <Typography
                        textAlign="center"
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +55%&nbsp;
                        </span>
                        than last week
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <LeaderboardIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#328ced",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Fake Leads
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +3%&nbsp;
                        </span>
                        than last month
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <PersonIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#4ea852",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Follow Leads
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +1%&nbsp;
                        </span>
                        than yesterday
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <EventIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#e12b6b",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Converted
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        Just updated
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={isMobileScreen ? 2 : isSmallScreen ? 2 : 4}
                sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <AssuredWorkloadIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#fb8c00",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          On Board Colleges
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +55%&nbsp;
                        </span>
                        than last week
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <SocialDistanceIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#ecb22e",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Partners
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +3%&nbsp;
                        </span>
                        than last month
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <SportsHandballIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#4ea852",
                              color: "white",
                              width: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              height: isMobileScreen
                                ? "15px"
                                : isSmallScreen
                                ? "20px"
                                : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          My Employees
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +1%&nbsp;
                        </span>
                        than yesterday
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={isMobileScreen ? 2 : isSmallScreen ? 2 : 4}
                sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <BookIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#dc395f",
                              color: "white",
                              width:  isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              height: isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Blogs Posted
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +55%&nbsp;
                        </span>
                        than last week
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <ReviewsIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "green",
                              color: "white",
                              width:  isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              height: isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          Blogs Under Review
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +3%&nbsp;
                        </span>
                        than last month
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    elevation={4}
                    sx={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px",
                    }}
                  >
                    <CardContent>
                      <Link to="" style={{ textDecoration: "none" }}>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: isMobileScreen
                              ? 12
                              : isSmallScreen
                              ? 12
                              : 15,
                          }}
                        >
                          <UnsubscribeIcon
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#fc9209",
                              color: "white",
                              width:  isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              height: isMobileScreen
                              ? "15px"
                              : isSmallScreen
                              ? "20px"
                              : "30px",
                              borderRadius: "20px",
                            }}
                          />
                          News Letter
                        </Typography>
                      </Link>
                      <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ my: isMobileScreen ? 1 : isSmallScreen ? 1 : 2 }}
                      />

                      <Typography
                        textAlign={"center"}
                        sx={{
                          fontSize: isMobileScreen
                            ? 12
                            : isSmallScreen
                            ? 12
                            : 15,
                        }}
                      >
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          +1&nbsp;
                        </span>
                        than yesterday
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
